const BID_INCREMENT_TIERS = [
  { upperBound: 200, step: 5 },
  { upperBound: 500, step: 10 },
  { upperBound: 1000, step: 25 },
  { upperBound: 5000, step: 100 },
  { upperBound: 10000, step: 250 },
  { upperBound: 50000, step: 500 },
  { upperBound: 100000, step: 1000 },
  { upperBound: 500000, step: 2000 },
];

const LOWEST_INCREMENT_STEP = BID_INCREMENT_TIERS[0].step;
const DEFAULT_HIGH_TIER_INCREMENT = 5000;

export const BID_FINAL_PHASE_BUFFER_MS = 10 * 60 * 1000;

export const deriveBidIncrement = (amount, options = {}) => {
  const { preferLowerTier = false } = options;
  if (!Number.isFinite(amount) || amount <= 0) {
    return LOWEST_INCREMENT_STEP;
  }

  const tierIndex = BID_INCREMENT_TIERS.findIndex(({ upperBound }) => amount < upperBound);
  const effectiveIndex = tierIndex === -1 ? BID_INCREMENT_TIERS.length : tierIndex;

  if (preferLowerTier) {
    if (effectiveIndex === 0) {
      return LOWEST_INCREMENT_STEP;
    }
    if (effectiveIndex >= BID_INCREMENT_TIERS.length) {
      return BID_INCREMENT_TIERS[BID_INCREMENT_TIERS.length - 1].step;
    }
    return BID_INCREMENT_TIERS[effectiveIndex - 1].step;
  }

  if (effectiveIndex < BID_INCREMENT_TIERS.length) {
    return BID_INCREMENT_TIERS[effectiveIndex].step;
  }

  return DEFAULT_HIGH_TIER_INCREMENT;
};

export const normalizeBidAmount = (amount, step) => {
  if (!Number.isFinite(amount) || !Number.isFinite(step) || step <= 0) {
    return 0;
  }
  return Math.ceil(amount / step) * step;
};

export const computeMinimumAllowedBid = (currentAmount, options = {}) => {
  const step = deriveBidIncrement(currentAmount, options);
  const normalizedCurrent = normalizeBidAmount(currentAmount, step);
  if (normalizedCurrent > currentAmount) {
    return normalizedCurrent;
  }
  return normalizeBidAmount(currentAmount + step, step);
};

export default {
  BID_FINAL_PHASE_BUFFER_MS,
  computeMinimumAllowedBid,
  deriveBidIncrement,
  normalizeBidAmount,
};
